import { ApiBase } from "./ApiBase";

export class TagAPI extends ApiBase
{
    async getTags(): Promise<{tags: string[]}>
    {
        const response = await this.fetch("tag");
        return response.json();
    }

   

    async removeTag(tag: string): Promise<void>
    {
        await this.fetch(`tag/${tag}`, {
            method: "DELETE",
        });
    }

}


// WEBPACK FOOTER //
// ./src/services/tag.ts